import { render, staticRenderFns } from "./CaseGuaranteedOverview.vue?vue&type=template&id=87da462a&scoped=true&"
import script from "./CaseGuaranteedOverview.vue?vue&type=script&lang=js&"
export * from "./CaseGuaranteedOverview.vue?vue&type=script&lang=js&"
import style0 from "./CaseGuaranteedOverview.vue?vue&type=style&index=0&id=87da462a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87da462a",
  null
  
)

export default component.exports